export default {
    loading() {
        window.toggleShow(true)
    },
    loaded() {
        window.toggleShow()
    },
}